define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/heading/stateColorResolver",
	"csi/types",
	"csi/xml"
], function(array, declare, stateColorResolver, types, xml) {
	var _reCompleteness = /(^0\/| 0%$)/;

	return declare(null, {
		/**
		 * Get the index of the state based on the context
		 * @param {Context} ctx
		 * @return {number}
		 */
		_getStateIndex: function(ctx) {
			const rollup = ctx.getNode();
			const cal = this._getCalendar(ctx, rollup);
			const masterActivity = this._getMasterActivity(ctx, cal);
			const dateTarget = masterActivity ? masterActivity.TargetDate : null;
			const dateComplete = this._getCalendarValue(ctx, rollup, "CompletionDate");

			// see if our activity is late.  ignore timestamps - just look at the dates themselves.
			const pastDue = dateComplete && dateTarget && types.getStartOfDay(dateComplete) > types.getStartOfDay(dateTarget);

			const stateIndex = this._getActivityState(dateTarget, dateComplete, this._getCalendarValue(ctx, rollup, "Completeness"), pastDue);

			return stateIndex;
		},

		_addCompletionCSS: function(/*Context*/ctx, /*String*/css) {
			const stateIndex = this._getStateIndex(ctx);
			const suffix = stateColorResolver.getStateCssByIndex("Calendar", stateIndex);

			if (suffix) {
				css += " " + suffix;
			}

			return css;
		},

		_getCalendarValue: function(/*Context*/ctx, /*Node*/rollup, /*String*/id) {
			// summary: get value for attribute - make sure to get indexed value if key
			var val = xml.nodeGetAttributeValue(rollup, id);
			return val ? val[ctx.keyValue] : null;
		},

		_getCalendar: function(/*Context*/ctx, /*Node?*/rollup) {
			return ctx.cache.getChildNode(rollup || ctx.getNode(), "__Parent__");
		},

		_getMasterActivity: function(/*Context*/ctx, /*Node?*/cal) {
			// summary: return master activity in current context
			var calMaster = ctx.cache.getChildNode(cal || this._getCalendar(ctx), "Master");
			var url = xml.nodeAttributeGetKeyValue(calMaster, "Activities", ctx.keyValue);
			return ctx.cache.getNode(url);
		},

		_getProtoActivity: function(/*Context*/ctx, /*Node?*/actMaster) {
			// summary: get master activity from master calendar at current index
			return ctx.cache.getChildNode(actMaster || this._getMasterActivity(ctx), "Proto");
		},

		_getActivityState: function(/*Number*/expected, /*Number*/completed, /*String*/value, /*Boolean*/pastDue) {
			// summary: return status color based on activity dates and value
			if (completed) {
				return pastDue ? 2 : 3; // 2 is LATE, 3 is COMPLETED
			} else if (expected && (expected < types.getDateTime(null, true))) {
				return 0;
			}

			if (value && !_reCompleteness.test(String(value))) {
				return 1;
			}

			return 4;
		}
	});
});